<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Richmond</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head" id="Ack"><a id="page_6">A<span class="small">CKNOWLEDGMENTS</span></a></p><a id="page_6">
<p class="para1">Nearly all the images included here belong to three institutions and will be marked as follows: Earlham College (EC), Morrisson-Reeves Library (MRL), and the Wayne County Historical Museum (WCHM). The authors acknowledge the assistance of their colleagues at Earlham and Morrisson-Reeves and extend special thanks to Jim Harlan at the Wayne County Historical Museum for his enthusiastic cooperation and support.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?ceb1f82e